export const emberNeutral = {
  50: '#EEEBF3',
  100: '#E2DEE8',
  200: '#D7D3DE',
  300: '#C4C0CD',
  400: '#A6A2B0',
  500: '#837E8D',
  600: '#5E5969',
  700: '#4C4658',
  800: '#413B4E',
  900: '#312A3F',
  950: '#282136',
};

export const emberPrimary = {
  50: '#FAEBE1',
  100: '#FAE0CD',
  200: '#F5D0B5',
  300: '#F5BF98',
  400: '#EBAE83',
  500: '#E09E6E',
  600: '#C4885C',
  700: '#A3724E',
  800: '#80583C',
  900: '#6B472D',
  950: '#573B28',
};

export const emberSecondary = {
  50: '#E2E1FA',
  100: '#CFCDFA',
  200: '#B8B5F5',
  300: '#9C98F5',
  400: '#8983EB',
  500: '#746EE0',
  600: '#615CC4',
  700: '#534EA3',
  800: '#3F3C80',
  900: '#302D6B',
  950: '#2A2857',
};

export const emberError = {
  50: '#FAE1E6',
  100: '#FACDD7',
  200: '#F5B5C3',
  300: '#F598AC',
  400: '#EB839A',
  500: '#E06E87',
  600: '#C45C73',
  700: '#A34E61',
  800: '#803C4B',
  900: '#6B2D3A',
  950: '#572832',
};

export const emberSuccess = {
  50: '#E1FAF2',
  100: '#CDFAEB',
  200: '#B5F5E0',
  300: '#98F5D6',
  400: '#83EBC8',
  500: '#6EE0BA',
  600: '#5CC4A2',
  700: '#4EA387',
  800: '#3C8069',
  900: '#2D6B56',
  950: '#285747',
};

export const emberWarning = {
  50: '#FAF1E1',
  100: '#FAE9CD',
  200: '#F5DDB5',
  300: '#F5D398',
  400: '#EBC583',
  500: '#E0B66E',
  600: '#C49E5C',
  700: '#A3844E',
  800: '#80673C',
  900: '#6B542D',
  950: '#574628',
};

export const emberInfo = {
  50: '#E1F6FA',
  100: '#CDF3FA',
  200: '#B5EBF5',
  300: '#98E7F5',
  400: '#83DBEB',
  500: '#6ECFE0',
  600: '#5CB5C4',
  700: '#4E96A3',
  800: '#3C7580',
  900: '#2D626B',
  950: '#285057',
};

export const emberBg = {
  light: '#FAFAF3',
  dark: '#1F182B',
};
